import crudHandlers from './_crud'

const initialState = {
    entities: [],
    selectedCommunication: null,
    loading: false,
    error: null,
    companies: [],
}

export default (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {

        case 'LOAD_COMMUNICATIONS':
            return {
                ...state,
                entities: Array.isArray(payload) ? payload : [],
                loading: false,
                error: null
            }

        case 'LOAD_COMPANIES':
            return {
                ...state,
                companies: action.payload
            }

        case 'LOAD_COMMUNICATION_BY_ID':
            return {
                ...state,
                selectedCommunication: payload, // Loads single communication by ID
            }

        case 'ADD_COMMUNICATION_SUCCESS':
            // Add the new communication to state
            return {
                ...state,
                entities: Array.isArray(state.entities)
                    ? [...state.entities, payload]
                    : (Object.values(state.entities)?.length>=1 && payload?.id)
                    ? {
                        ...state.entities,
                        [payload?.id]: payload,
                    }
                    : state.entities

            }

        case 'DELETE_COMMUNICATION_SUCCESS':
            // Remove the deleted communication from state
            return {
                ...state,
                entities: Array.isArray(state.entities)
                    ? state.entities.filter((comm) => comm.id !== payload)
                    : [],
            }

        default:
            // Handles the remaining CRUD actions
            state = crudHandlers(state, action, 'communications')
            return state
    }
}
